import { render, staticRenderFns } from "./CompleteDistribution.vue?vue&type=template&id=81bcbb56&scoped=true&lang=pug&"
import script from "./CompleteDistribution.vue?vue&type=script&lang=js&"
export * from "./CompleteDistribution.vue?vue&type=script&lang=js&"
import style0 from "./CompleteDistribution.vue?vue&type=style&index=0&id=81bcbb56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bcbb56",
  null
  
)

export default component.exports